import type { SessionValues } from './types';

export const SESSION_KEY = 'session_values' as const;

export const DEFAULT_SESSION_VALUES = {
  token: undefined!,
  tokenExp: undefined!,
  userId: undefined!,
  organizationId: undefined!,
  customerId: undefined!,
  restrictedToIpAddress: undefined,
  segments: [],
  isExpired: false,
} as const satisfies SessionValues;
